import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { styles } from '../../constants';

import { Button, Text, Form, Item, Label, Input, H3, Content, CardItem, Card } from "native-base";
import {
    sendRegistration,
    setCurrentAction
} from '../../actions/';


class Registration extends Component {
    state = {
        // key: "7e649ecb733d2af1",
        // email: "info@umkb.ru" + (Math.floor(Math.random() * 10000000)),
        // password: "1qasw23ed",
        // lastName: "Тестов",
        // firstName: "Тест",
        // middleName: "Тестович",
        // lpuName: '',
        // department: '',
        // hidden: true,
        email: "",
        password: "",
        lastName: "",
        firstName: "",
        middleName: "",
        lpuName: '',
        department: '',
        hidden: true
    }

    onChangeInput = (key, e) => this.setState({ [key]: e.target.value });
    onChangePass = e => this.setState({ password: e.target.value });

    handlerSubmit = () => {
        const { dispatch } = this.props;
        dispatch(sendRegistration(this.state));
    };

    handlerClickLogin = (event) => {
        const { dispatch } = this.props;
        event.preventDefault();
        dispatch(setCurrentAction('login'));
    };

    render() {
        const { authCause, currentAction } = this.props;
        const { email, firstName, middleName, lastName, lpuName, department, password } = this.state;

        return <Content style={styles.content}>
            <Form>
                <H3 style={styles.appDescription}>Регистрация</H3>

                {currentAction === 'registrationSuccess' ? <Text>Для завершения регистрации необходимо перейти по ссылке в письме, которое Вы получите в течении нескольких минут.</Text> :
                    <>
                        <Item stackedLabel>
                            <Label>Email*</Label>
                            <Input
                                keyboardType="email-address"
                                onChange={(e) => this.onChangeInput('email', e)}
                                value={email}
                            />
                        </Item>
                        <Item stackedLabel>
                            <Label>Имя*</Label>
                            <Input
                                onChange={(e) => this.onChangeInput('firstName', e)}
                                value={firstName}
                            />
                        </Item>
                        <Item stackedLabel>
                            <Label>Отчество</Label>
                            <Input
                                onChange={(e) => this.onChangeInput('middleName', e)}
                                value={middleName}
                            />
                        </Item>
                        <Item stackedLabel>
                            <Label>Фамилия*</Label>
                            <Input
                                onChange={(e) => this.onChangeInput('lastName', e)}
                                value={lastName}
                            />
                        </Item>
                        <Item stackedLabel>
                            <Label>Название учреждения</Label>
                            <Input
                                onChange={(e) => this.onChangeInput('lpuName', e)}
                                value={lpuName}
                            />
                        </Item>
                        <Item stackedLabel>
                            <Label>Название отделения</Label>
                            <Input
                                onChange={(e) => this.onChangeInput('department', e)}
                                value={department}
                            />
                        </Item>
                        <Item stackedLabel>
                            <Label>Пароль*</Label>
                            <Input
                                secureTextEntry={true}
                                onChange={this.onChangePass}
                                value={password}
                            />
                        </Item>
                        <Button
                            large
                            full
                            rounded
                            onPress={this.handlerSubmit}
                            style={styles.button}
                        >
                            <Text>Регистрация</Text>
                        </Button>
                    </>}
                <Button transparent block style={styles.bottomLink} onPress={this.handlerClickLogin}>
                    <Text>Вход</Text>
                </Button>
                {authCause ? <Card>
                    <CardItem>
                        <Text>{authCause}</Text>
                    </CardItem>
                </Card> : null}
            </Form>
        </Content>;
    }
}

Registration.propTypes = {
    dispatch: PropTypes.func.isRequired,
    authCause: PropTypes.string,
    currentAction: PropTypes.string
};

Registration.defaultProps = {
    authCause: ''
};

const mapStateToProps = (state) => ({
    authCause: state.authCause,
    currentAction: state.currentAction
});

export default connect(mapStateToProps)(Registration);
